import React from 'react';
import { Flame, Hand, Volume2, Radio, DoorOpen, SquareSlash, Thermometer, Circle } from 'lucide-react';

const COMPONENT_ICONS = {
  smoke_detector: Flame,
  manual_call_point: Hand,
  siren: Volume2,
  motion: Radio,
  door_contact: DoorOpen,
  glass_break: SquareSlash,
  heat_detector: Thermometer,
  other: Circle
};

const STATUS_COLORS = {
  normal: '#6B7280',
  alarm: '#EF4444',
  fault: '#F59E0B',
  sabotage: '#F97316'
};

const ComponentIcon = ({ type, number, status = 'normal', size = 32 }) => {
  const Icon = COMPONENT_ICONS[type] || COMPONENT_ICONS.other;
  const color = STATUS_COLORS[status] || STATUS_COLORS.normal;
  const isAnimated = status === 'alarm' || status === 'sabotage';
  const isBlink = status === 'fault';

  return (
    <div
      className={`relative inline-flex items-center justify-center ${isAnimated ? 'animate-pulse' : ''} ${isBlink ? 'animate-blink' : ''}`}
      style={{ width: size, height: size }}
    >
      <Icon
        size={size * 0.75}
        color={color}
        fill={status !== 'normal' ? color : 'none'}
        strokeWidth={2}
      />
      {number !== undefined && (
        <span
          className="absolute -bottom-1 -right-1 bg-white text-xs font-bold rounded-full px-1 shadow border"
          style={{
            color: color,
            fontSize: size * 0.35,
            minWidth: size * 0.5,
            textAlign: 'center'
          }}
        >
          {number}
        </span>
      )}
    </div>
  );
};

export default ComponentIcon;
